import { systemAuditConstants } from '../_constants';
import { systemAuditService } from '../_services';

export const systemAuditAction = {
    getAllSystemAudits,
    getSystemAuditTopCardInfo, 
    applyFilter,
    fetchSystemAuditFilters,
};

function getAllSystemAudits(offset,limit) {
    return dispatch => {
        dispatch(request());
        systemAuditService.getAllSystemAudits(offset,limit)
            .then(
                systemAudit => dispatch(success(systemAudit)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_REQUEST } }
    function success(systemAudit) { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_SUCCESS, systemAudit } }
    function failure(error) { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FAILURE, error } }
}

function getSystemAuditTopCardInfo() {
    return dispatch => {
        dispatch(request());
        systemAuditService.getSystemAuditTopCardInfo()
            .then(
                systemAuditCards => dispatch(success(systemAuditCards)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: systemAuditConstants.SYSTEM_AUDIT_TOP_CARD_REQUEST } }
    function success(systemAuditCards) { return { type: systemAuditConstants.SYSTEM_AUDIT_TOP_CARD_SUCCESS, systemAuditCards } }
    function failure(error) { return { type: systemAuditConstants.SYSTEM_AUDIT_TOP_CARD_FAILURE, error } }
}

function applyFilter(model,
    operation,
     user,
     startDate,
     endDate,
     search,
     offset,
     limit) {
    return dispatch => {
        dispatch(request());
        systemAuditService.applyFilter(
            model,
            operation,
             user,
             startDate,
             endDate,
             search,
             offset,
             limit)
            .then(
                systemAudit => dispatch(success(systemAudit)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_REQUEST } }
    function success(systemAudit) { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_SUCCESS, systemAudit } }
    function failure(error) { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FAILURE, error } }
}

//fetchSystemAuditFilters
function fetchSystemAuditFilters(){
    return (dispatch)=>{
        dispatch(request());
        systemAuditService.fetchSystemAuditFilters().then(
            (auditFilters)=>{
                dispatch(success(auditFilters));
            },
            (error)=>{
                dispatch(failure(error.toString())); 
            }
        );
    }
    function request() { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FILTERS_REQUEST } }
    function success(auditFilters) { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FILTERS_SUCCESS, auditFilters } }
    function failure(error) { return { type: systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FILTERS_FAILURE, error } }
}